import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { assetWithdraw, verifyWallet } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "Component/Common/Loader";
import useToastr from "helpers/toastr";
import { useTranslation } from "react-i18next";
import ScrollLockModal from "Component/Common/ScrollLock-Model";
import Web3 from "web3";

export default function WithrawModel(props) {
  const [fields, setFields] = useState({
    amount: "",
    address: "",
    note: "",
  });
  const dispatch = useDispatch();
  const { user } = useSelector(({ Login }) => Login);
  const { loading } = useSelector((state) => state?.Wallet);
  const { walletLoading } = useSelector((state) => state?.Price);
  const [isHovered, setIsHovered] = useState(false);

  const toastr = useToastr();
  const { t } = useTranslation();

  /**
   * Used for submit the input details in withdraw
   */

  const handleSubmit = (e) => {
    if (fields.amount == "" || fields.address == "" || fields.note == "") {
      return toastr.error(t("all_fields_required"));
    }
    if (fields.amount == 0 || fields.amount < 0) {
      return toastr.error(t("add_amount"));
    }

    if (fields.amount > props.selectedAsset?.available) {
      return toastr.error(t("insuficient_balance"));
    }
    const callback = (response) => {
      if (response.status == "success") {
        toastr.success(response.message);
        props.onHide();
        setFields((prev) => ({
          ...prev,
          amount: "",
          address: "",
          note: "",
        }));
      } else {
        toastr.error(response.message);
      }
    };

    const info = {
      amount: fields?.amount,
      address: fields?.address?.trim(),
      note: fields?.note,
      userId: user?._id,
      assetId: props.selectedAsset?.id,
    };

    dispatch(assetWithdraw(info, callback));
  };

  /**
   * Used for control the input states
   */
  const handleChange = (name) => (e) => {
    if (name === "address") {
      const isValidAddress = Web3.utils.isAddress(e.target.value.trim());
      if (!isValidAddress) {
        toastr.error("Invalid Address");
        return;
      }
    }
    setFields((prev) => ({ ...prev, [name]: e.target.value }));
  };

  /**
   * Used for render the UI of withdraw model
   */
  return (
    <ScrollLockModal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="buy_modal Tranferconfirm-modal"
    >
      {loading || (walletLoading && <Loader />)}

      <div className="modal_inner_main position-relative">
        <a
          href="javascript:void(0)"
          onClick={() => {
            props.onHide();
            setFields((prev) => ({
              ...prev,
              amount: "",
              address: "",
              note: "",
            }));
          }}
          className="close-btn"
        >
          <img src="/images/close_img.png" alt="" className="img-fluid" />
        </a>

        <div className="modal_buy-cont">
          <div className="slected_currency_top d-flex align-items-center">
            <div className="slected_curreny me-3">
              <img
                src={props.selectedAsset && props.selectedAsset?.icon}
                alt=""
                className="img-fluid"
              />
            </div>
            <p>{props.selectedAsset && props.selectedAsset?.name}</p>
          </div>

          <Row>
            <Col lg={12} sm={12}>
              <FormGroup>
                <Label for="exampleEmail">
                  {t("amount")}{" "}
                  <span className="col_red">
                    <sup>*</sup>
                  </span>
                </Label>
                <Input
                  type="number"
                  name="amount"
                  id="amount"
                  placeholder={t("enter_amount")}
                  onChange={handleChange("amount")}
                  required
                  value={fields?.amount}
                  step={"any"}
                  title={t("fill_this_field")}
                  min={0}
                />
              </FormGroup>
            </Col>
            <Col lg={12} sm={12}>
              <FormGroup>
                <Label for="exampleEmail">
                  {t("wallet_address")}
                  <span className="col_red">
                    <sup>*</sup>
                  </span>
                </Label>
                <Input
                  type="text"
                  name="address"
                  id="address"
                  placeholder={t("enter_address")}
                  onChange={handleChange("address")}
                  required
                  title={t("fill_this_field")}
                />
              </FormGroup>
            </Col>
            <Col lg={12} sm={12}>
              <FormGroup>
                <Label for="exampleEmail">
                  {t("note")}{" "}
                  <span className="col_red">
                    <sup>*</sup>
                  </span>
                </Label>
                <Input
                  type="textarea"
                  name="note"
                  id="note"
                  placeholder={t("enter_note")}
                  onChange={handleChange("note")}
                  required
                  title={t("fill_this_field")}
                />
              </FormGroup>
            </Col>
          </Row>

          <div className="modal_buy_btn d-flex justify-content-center gap-3">
            <Button
              className="mod_cancelbtn clomod_btn"
              onClick={() => {
                props.onHide();
              }}
            >
              {t("close")}
            </Button>

            <Button
              className="mod_confirmbtn copy_btn"
              onClick={handleSubmit}
              type="submit"
              disabled={
                fields.amount == "" ||
                fields.address == "" ||
                (fields.note == "" && true)
              }
            >
              {t("withdraw")}
            </Button>
          </div>
        </div>
      </div>
    </ScrollLockModal>
  );
}
